import { getWordOfDay } from '../../lib/words'
import { loadGameStateForWordCount } from '../../lib/localStorage'
import { MAX_CHALLENGES } from '../../constants/settings'
import { getStoredIsHighContrastMode } from '../../lib/localStorage'

import classnames from 'classnames'

type Props = {
  wordCount: number
  gameName: string
}

export const OodleLink = ({ wordCount, gameName }: Props) => {
  const { solution } = getWordOfDay(wordCount)
  const loaded = loadGameStateForWordCount(wordCount)
  var success = 'maybe'
  if (loaded) {
    if (loaded?.solution === solution) {
      // make sure it is today's game
      if (loaded.guesses) {
        const numGuesses = loaded.guesses.length
        const guessedSolution = loaded.guesses[numGuesses - 1]
        if (guessedSolution === solution) {
          success = 'yes'
        } else if (numGuesses === MAX_CHALLENGES) {
          success = 'no'
        }
      }
    }
  }

  //console.debug("success=%s, count=%d, solution=%s, gameStateSolution=%s, numGuesses=%s\n",
  //  success, wordCount, solution, loaded?.solution, loaded?.guesses)

  const isHighContrast = getStoredIsHighContrastMode()

  const classes = classnames(
    'mr-1 w-5 h-5 font-bold rounded-full',
    'items-center justify-center font-mono',
    'border-solid border-3 border-black dark:border-white',
    'shadowed text-xs',
    'text-white dark:text-white flex border-black dark:border-white border-2',
    {
      'bg-green-500': success === 'yes' && !isHighContrast,
      'bg-orange-500': success === 'yes' && isHighContrast,
      'bg-slate-400 dark:bg-slate-700': success === 'maybe',
      'bg-red-500': success === 'no' && !isHighContrast,
      'bg-cyan-500': success === 'no' && isHighContrast,
    }
  )
  //console.debug("classes=%s", classes)

  const url = '../' + gameName + '/index.html'

  return (
    <a href={url}>
      <div className={classes}>{wordCount}</div>
    </a>
  )
}
